import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { PlainTextInput } from "@/lib/Components/Form/Inputs/PlainTextInput";

export function SupplierAcknowledgementForm() {
  return (
    <>
      <TextInput name="name" label="Name" />
      <PlainTextInput
        name="acknowledgement"
        label="Acknowledgement"
        className="col-span-full"
        availableReplacements={["{bond_amount}", "{standard_liability_amount}"]}
      />
    </>
  );
}
